import { useEffect, useState } from 'react';
import { matchPath, Outlet, useNavigate } from 'react-router-dom';
import { Loader } from '@/components/Loader';
import { LoginContainer } from '@/components/LoginContainer';
import { useKioskStore } from '@/stores/kiosk';
import { useUsersStore } from '@/stores/users';
import { EKioskRouterNames } from '@/types';

const pathNotNeedLoginContainer = [
  `${EKioskRouterNames.KIOSK}/${EKioskRouterNames.KIOSK__CONTINUE}`,
];

export const LoginInKioskLayout = () => {
  const navigate = useNavigate();

  const withoutHeaderAndFooter = pathNotNeedLoginContainer.some((path) =>
    matchPath(path, location.pathname),
  );

  const userData = useUsersStore((state) => state.userData);

  const kioskInstitution = useKioskStore((state) => state.kioskInstitution);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (userData) {
      navigate(EKioskRouterNames.KIOSK);
      return;
    }
    setLoading(false);
  }, [navigate, userData]);

  if (loading) {
    return <Loader />;
  }

  if (withoutHeaderAndFooter) {
    return <Outlet />;
  }

  return (
    <LoginContainer
      background={
        (kioskInstitution?.whitelabel?.enabled &&
          kioskInstitution?.whitelabel?.coverImageUrl) ||
        undefined
      }
      showKioskFooter
    >
      <Outlet />
    </LoginContainer>
  );
};
